/**
 * Print device registration (README.md Phase 17.4). A `PrintDevice` row is
 * how a shop tells the API "there's a real printer reachable at this address
 * via this protocol" — the print agent (not built yet) connects as one of
 * these; `apps/web`'s print button checks whether one exists for the active
 * shop before deciding to hand a job to the agent vs. falling back to the
 * browser print dialog (Phase 17.5).
 */
import { z } from 'zod';
import { idSchema, paginationSchema } from './common.js';
import { PRINT_DEVICE_CONNECTIONS, PRINT_DEVICE_KINDS, PRINT_PROTOCOLS } from '../constants.js';
export const createPrintDeviceSchema = z.object({
    shopId: idSchema,
    name: z.string().min(1).max(120),
    kind: z.enum(PRINT_DEVICE_KINDS),
    protocol: z.enum(PRINT_PROTOCOLS).default('ESCPOS'),
    connection: z.enum(PRINT_DEVICE_CONNECTIONS).default('USB'),
    address: z.string().max(200).optional(),
    paperWidthMm: z.number().int().min(1).max(1000).optional(),
    isDefault: z.boolean().default(false),
});
export const updatePrintDeviceSchema = createPrintDeviceSchema
    .omit({ shopId: true })
    .partial()
    .extend({ isActive: z.boolean().optional() });
export const listPrintDevicesQuerySchema = paginationSchema.extend({
    shopId: idSchema.optional(),
    kind: z.enum(PRINT_DEVICE_KINDS).optional(),
});
//# sourceMappingURL=print-devices.js.map